<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Button type="text" shape="circle" icon="ios-search" @click="()=>{this.showSearchDrawer = true}"></Button>
        <div id="exceptionChart" :style="echartStyle">
        </div>
        <Drawer title="检索条件" v-model="showSearchDrawer" width="360" :styles="styles" :inner="true" :transfer="false">
            <Form :model="formSearch">
                <FormItem label="时间" label-position="top">
                    <DatePicker :transfer="true" v-model="formSearch.echartDate" type="datetime" split-panels
                        placeholder="不筛选时间..." :options="datePickerOptions" style="width:326px;" :clearable="false"></DatePicker>
                </FormItem>
                <FormItem label="时间类型" label-position="top">
                    <Select :transfer="true" v-model="formSearch.echartDateType" @on-change="changeDateType">
                        <Option value="YEAR">年</Option>
                        <Option value="QUARTER">季度</Option>
                        <Option value="MONTH">月</Option>
                        <Option value="WEEK">星期</Option>
                        <Option value="DAY">日</Option>
                        <Option value="HOUR">时</Option>
                        <Option value="MINUTE">分</Option>
                        <Option value="SECOND">秒</Option>
                    </Select>
                </FormItem>
                <FormItem label="间隔周期" label-position="top">
                    <Select :transfer="true" v-model="formSearch.echartDateCircle">
                        <Option v-for="item in [1,2,3,4,5,10]" :value="item" :key="item">{{item}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="地址" label-position="top">
                    <Cascader :transfer="true" v-model="formSearch.echartAddress" :data="addressData" change-on-select
                        filterable :render-format="formatAddress" transfer @on-change="choiceAddress" :clearable="false"></Cascader>
                </FormItem>
                <div style="width: 100%; position: absolute; bottom: 0; left: 0; border-top: 1px solid #e8e8e8;
                            padding: 10px 16px; text-align: right; background: #fff;">
                    <Button icon="ios-search" type="primary" long @click="onCommit">检索</Button>
                </div>
            </Form>
        </Drawer>
        <Drawer title="报警类目设置" v-model="showCategoryDrawer" width="360" :styles="styles" :inner="true" :transfer="false">
            <Form>
                <div v-for="(item,index) in Object.keys(error)" :key="index">
                    <Badge :status="badgeStatus['exceptionStatus'+item]" />
                    <Button id="textButton" type="text" size="small"
                        onclick="this.blur()" @click="onChoose(item)" >
                        {{error[item].name}}
                    </Button>
                </div>
                <div style="width: 100%; position: absolute; bottom: 0; left: 0; border-top: 1px solid #e8e8e8;
                            padding: 10px 16px; text-align: right; background: #fff;">
                    <Button type="primary" long @click="reloadX">设置</Button>
                </div>
            </Form>
        </Drawer>
    </div>
</template>

<script>
    //import walden from './walden.js'
    export default {
        name: "eCharts_exception",
        computed: {
            echartStyle() {
                var style = {};
                style.width = this.width * 0.8 + 'px';
                style.height = this.height * 0.76 + 'px';
                return style;
            }
        },
        mounted() {
            var that = this;
            that.error = global.errorMsgParam;
            this.option.baseOption.xAxis[0].data = [];
            Object.keys(that.error).map(item => {
                var itemParam = that.error[item].name;
                this.option.baseOption.xAxis[0].data.push(itemParam);
            });

            this.option.baseOption.timeline.data = [];
            var nowDate = new Date(this.formSearch.echartDate);
            for (let i = 0; i < 10; i++) {
                this.option.baseOption.timeline.data.push(
                    global.dateFtt("MM-dd", nowDate.dateAdd('DAY', 1))
                );
            }

            //获得地址
            $.ajax({
                url: "/api/getAddressTree",
                contentType: "application/json",
                async: false,
                type: "get",
                dataType: "json",
                success: function(data) {
                    if (data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }
                    that.addressData = data.body[0].children;
                    that.addressRange = data.body[0].children[0].name;
                    that.formSearch.echartAddress.push(data.body[0].children[0].id);
                    that.getData();
                },
                error: function(textStatus) {
                    that.$Notice.error({
                        title: "异常",
                        desc: "接口请求异常"
                    });
                }
            });
        },
        data() {
            return {
                receiveExceptionData: {},
                badgeStatus: {
                    exceptionStatus0: "success",
                    exceptionStatus1: "success",
                    exceptionStatus2: "success",
                    exceptionStatus3: "success",
                    exceptionStatus4: "success",
                    exceptionStatus5: "success",
                    exceptionStatus6: "success",
                    exceptionStatus7: "success",
                    exceptionStatus8: "success",
                    exceptionStatus9: "success",
                    exceptionStatus10: "success",
                    exceptionStatus11: "success",
                    exceptionStatus12: "success",
                    exceptionStatus13: "success",
                    exceptionStatus14: "success",
                    exceptionStatus15: "success",
                    exceptionStatus16: "success",
                    exceptionStatus17: "success",
                    exceptionStatus18: "success",
                    exceptionStatus19: "success",
                    exceptionStatus20: "success",
                    exceptionStatus21: "success",
                    exceptionStatus22: "success",
                    exceptionStatus23: "success",
                    exceptionStatus24: "success",
                    exceptionStatus25: "success",
                    exceptionStatus26: "success",
                    exceptionStatus27: "success"
                },
                error: [],
                isSpinShow: false,
                addressData: [],
                addressRange: "",
                datePickerOptions: {
                    shortcuts: [{
                        text: '一周前',
                        value() {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            return date;
                        }
                    }, {
                        text: '昨天',
                        value() {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            return date;
                        }
                    }, {
                        text: '现在',
                        value() {
                            const date = new Date();
                            return date;
                        }
                    }]
                },
                formSearch: {
                    echartDate: global.dateFtt("yyyy-MM-dd hh:mm:ss",
                        new Date(new Date().getTime() - 3600 * 1000 * 24 * 10)),
                    echartDateType: "DAY",
                    echartDateCircle: 1,
                    echartAddress: []
                },
                showSearchDrawer: false,
                showCategoryDrawer: false,
                styles: {
                    height: 'calc(100% - 55px)',
                    overflow: 'auto',
                    paddingBottom: '53px',
                    position: 'static'
                },
                height: document.body.clientHeight,
                width: document.body.clientWidth,
                option: {
                    baseOption: {
                        timeline: {
                            axisType: 'category',
                            autoPlay: true,
                            playInterval: 3000,
                            data: [],
                            label: {
                                // formatter: function(s) {
                                //     return (new Date(s)).getFullYear();
                                // }
                            }
                        },
                        title: {
                            subtext: '报警信息统计'
                        },
                        tooltip: {
                        },
                        legend: {
                            x: 'right',
                            data: []
                        },
                        calculable: true,
                        grid: {
                            left: '5%',
                            right: '2%',
                            top: 80,
                            bottom: 100,
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow',
                                    label: {
                                        show: true,
                                        formatter: function(params) {
                                            return params.value.replace('\n', '');
                                        }
                                    }
                                }
                            }
                        },
                        xAxis: [{
                            'type': 'category',
                            'axisLabel': {
                                'interval': 0,
                                'inside': false,
                                'rotate': -30
                            },
                            triggerEvent : true,
                            data: [],
                            splitLine: {
                                show: false
                            }
                        }],
                        yAxis: [{
                            type: 'value',
                            name: '次'
                        }],
                        series: []
                    },
                    options: []
                }
            };
        },
        methods: {
            load(){
                let exceptionChart = this.$echarts.init(document.getElementById("exceptionChart"));
                exceptionChart.setOption(this.option, true);
                var that = this;
                exceptionChart.on('click', function (params) {
                    if(params.componentType == "xAxis"){
                        that.showCategoryDrawer = true;
                    }else{
                    }
                }); 
            },
            reloadX(){
                this.option.baseOption.xAxis[0].data = [];
                Object.keys(this.error).map(item => {
                    var itemParam = this.error[item].name;
                    if (this.badgeStatus["exceptionStatus"+item] == "success"){
                        this.option.baseOption.xAxis[0].data.push(itemParam);
                    }
                });
                this.showData();
                this.load();
                this.showCategoryDrawer = false;
            },
            onChoose(item){
                if (this.badgeStatus["exceptionStatus"+item] == "success") {
                    this.badgeStatus["exceptionStatus"+item] = "error";
                } else if (this.badgeStatus["exceptionStatus"+item] == "error") {
                    this.badgeStatus["exceptionStatus"+item] = "success";
                }
            },
            formatAddress(labels, selectedData) {
                this.addressRange = labels.join('');
                return labels.join(' / ');
            },
            onCommit() {
                this.option.baseOption.timeline.data = [];
                let dateFormat = "yy-MM-dd hh:mm:ss";
                switch (this.formSearch.echartDateType) {
                    case "YEAR":
                        dateFormat = "yy-MM";
                        break;
                    case "QUARTER":
                        dateFormat = "yy-MM";
                        break;
                    case "MONTH":
                        dateFormat = "yy-MM";
                        break;
                    case "WEEK":
                        dateFormat = "MM-dd";
                        break;
                    case "DAY":
                        dateFormat = "MM-dd";
                        break;
                    case "HOUR":
                        dateFormat = "hh:mm";
                        break;
                    case "MINUTE":
                        dateFormat = "hh:mm:ss";
                        break;
                    case "SECOND":
                        dateFormat = "hh:mm:ss";
                        break;
                    default:
                        dateFormat = "yy-MM-dd hh:mm:ss";
                        break;
                }
                for (let i = 0; i < 10; i++) {
                    this.option.baseOption.timeline.data.push(
                        global.dateFtt(dateFormat, new Date(this.formSearch.echartDate)
                            .dateAdd(this.formSearch.echartDateType, i * this.formSearch.echartDateCircle))
                    );
                }
                this.getData();
                this.showSearchDrawer = false;
            },
            getData() {
                var that = this;
                that.isSpinShow = true;
                //请求设备基础数据
                $.ajax({
                    url: "/api/instructions/getCountException",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(that.formSearch),
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: receiveData.errorInfo
                            });
                            return;
                        }
                        that.receiveExceptionData = receiveData.body;
                        that.showData();
                        that.isSpinShow = false;
                        that.load();
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
                //console.log(JSON.stringify(this.option))
            },
            showData(){
                var that = this;
                that.option.options = [];
                that.option.baseOption.legend.data = [];
                that.option.baseOption.series = [];
                that.receiveExceptionData.map((timeParam, indexF) => {
                    let param = {};
                    if (timeParam.length > 0) {
                        param['title'] = {};
                        param['title']['text'] = that.addressRange + '报警统计';
                        param['series'] = [];
                    }
                    timeParam.map(item => {
                        let dateCell = [];
                        var j = 0;
                        for (var i = 0; i < 28; i++) {
                            if (that.badgeStatus["exceptionStatus"+i] == "success"){
                                dateCell[j] = {};
                                dateCell[j]['name'] = item["addressName" + (that.formSearch
                                    .echartAddress.length + 1)];
                                dateCell[j]['value'] = item['errorNumber' + i];
                                j++;
                            }
                        }
                        var tempParam = {};
                        tempParam['data'] = dateCell;
                        param.series.push(tempParam);
                        if (that.option.baseOption.legend.data.indexOf(item[
                                "addressName" + (that.formSearch.echartAddress.length +
                                    1)]) == -1) {
                            that.option.baseOption.legend.data.push(item[
                                "addressName" + (that.formSearch.echartAddress
                                    .length + 1)]);
                        }
                        if (indexF == 0) {
                            var seriesParam = {};
                            seriesParam['name'] = item["addressName" + (that.formSearch
                                .echartAddress.length + 1)];
                            seriesParam['type'] = 'bar';
                            that.option.baseOption.series.push(seriesParam);
                        }
                    });
                    var pieData = {data: []};
                    timeParam.map(item => {
                        var exceptionSum = 0;
                        for (var i = 0; i < 28; i++) {
                            if (that.badgeStatus["exceptionStatus"+i] == "success"){
                                exceptionSum += item['errorNumber' + i];
                            }
                        }
                        pieData.data.push({
                                name: item["addressName" + (that.formSearch.echartAddress.length + 1)], 
                                value: exceptionSum,
                            });
                    });
                    param.series.push(pieData);
                    that.option.options.push(param);
                });
                that.option.baseOption.series.push({
                    name: '报警合计',
                    type: 'pie',
                    center: ['90%', '30%'],
                    radius: '25%',
                    z: 100
                });
            },
            choiceAddress(param) {
                this.formSearch.echartAddress = param;
            },
            changeDateType() {
            }
        }
    }
    Date.prototype.dateAdd = function(interval, number) {
        var d = this;
        var k = {
            'YEAR': 'FullYear',
            'QUARTER': 'Month',
            'MONTH': 'Month',
            'WEEK': 'Date',
            'DAY': 'Date',
            'HOUR': 'Hours',
            'MINUTE': 'Minutes',
            'SECOND': 'Seconds',
            'ms': 'MilliSeconds'
        };
        var n = {
            'QUARTER': 3,
            'WEEK': 7
        };
        eval('d.set' + k[interval] + '(d.get' + k[interval] + '()+' + ((n[interval] || 1) * number) + ')');
        return d;
    }
</script>

<style>
    
</style>
